import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDiagramTree20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDiagramTree20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 4.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16 6a2 2 0 1 0-1.855-2.75H14A2.75 2.75 0 0 0 11.25 6v3.25H8.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a2 2 0 0 0 2-2v-3.25h2.75V14A2.75 2.75 0 0 0 14 16.75h.145a2 2 0 1 0 0-1.5H14c-.69 0-1.25-.56-1.25-1.25v-3.25h1.395a2 2 0 1 0 0-1.5H12.75V6c0-.69.56-1.25 1.25-1.25h.145A2 2 0 0 0 16 6M4 5.5h2.5A.5.5 0 0 1 7 6v8a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5M16.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDiagramTree20);
